import React from "react";

/**
 * CardStack — PLACEHOLDER for Phase 4 seller flow.
 * Will support drag/swipe in Phase 4. Here we render the top card layout only.
 */
export function CardStack({ card, hint, testId }) {
    return (
        <div
            data-testid={testId || "card-stack"}
            className="relative mx-auto flex aspect-[3/4] w-full max-w-xs items-center justify-center"
        >
            <div className="absolute inset-0 -rotate-3 scale-95 rounded-2xl border border-md-border bg-md-surface-2/60" />
            <div className="absolute inset-0 rotate-2 scale-[0.97] rounded-2xl border border-md-border bg-md-surface-2" />
            <div className="relative flex h-full w-full flex-col rounded-2xl border border-md-border bg-md-surface p-6 shadow-xl">
                {card ? (
                    <>
                        <p className="md-overline text-md-text-2">
                            {card.set} · {card.rarity}
                        </p>
                        <p className="mt-2 text-7xl font-black tracking-tighter text-md-text">
                            {card.number || "—"}
                        </p>
                        <p className="mt-3 text-2xl font-bold leading-tight text-md-text">
                            {card.name || "Carte inconnue"}
                        </p>
                        <div className="mt-auto rounded-xl bg-md-surface-2 p-4 text-center text-xs text-md-text-2">
                            {hint || "Stack vendeur — disponible en Phase 4"}
                        </div>
                    </>
                ) : (
                    <div className="m-auto text-center">
                        <p className="md-overline">Aperçu</p>
                        <p className="mt-3 text-3xl font-bold text-md-text">Stack vendeur</p>
                        <p className="mt-2 text-sm text-md-text-2">
                            Le moteur de swipe arrive en Phase 4.
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
}

export default CardStack;
